import React from 'react';
import { Table, Button } from 'antd';
import { withRouter } from 'react-router';
import moment from 'moment';
import PropTypes from 'prop-types';

import Breadcrumbs from '@sp/client/components/Breadcrumbs';
import NavBar from '@sp/client/components/NavBar';

import s from './style.less';

class CustomerPlanPayments extends React.Component {
  static propTypes = {
    match: PropTypes.object,
  };
  state = {
    list: [],
    plan: false,
  };

  componentDidMount() {
    this.fetchList();
  }

  breadcrumbs = [
    { name: 'Home', to: '/customer/plans' },
    { name: 'My Payments', to: '/customer/payments' },
    { name: 'Plan payments' },
  ];

  columns = [
    {
      title: 'Payment date',
      dataIndex: 'gcPaidAt',
      key: 'gcPaidAt',
      render: date => moment(date).format('DD/MM/YYYY'),
    },
    {
      title: 'Amount',
      dataIndex: 'amount',
      key: 'aomunt',
    },
    {
      title: 'Documents',
      key: 'doc',
      render: payment => (
        <span>
          <a
            href={`/reports/payments/${payment.type}/${payment.id}`}
            download={`${this.state.plan.contractNumber}-${payment.id}.pdf`}
          >
            <Button type="primary">Download</Button>
          </a>
        </span>
      ),
    },
  ];

  fetchList = async () => {
    const { id } = this.props.match.params;
    const data = await fetch(`/customer/my-payments/${id}`);
    this.setState({ list: data.list, plan: data.plan });
  };

  render() {
    const { list } = this.state;

    return (
      <NavBar withPadding>
        <Breadcrumbs paths={this.breadcrumbs} />
        <div className={s.title}>Payments {this.state.plan.contractNumber}</div>
        <Table columns={this.columns} rowKey="id" dataSource={list} />
      </NavBar>
    );
  }
}

export default withRouter(CustomerPlanPayments);
